import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import {getSignedPercentComma} from "../../utils/percents_handling_helpers";

interface Props {
    yearOverYearPct: number | null;
    className?: string;
}

export const PricesDistrictChangeBadge = (props: Props) => {
    const {yearOverYearPct, className} = props;

    if (yearOverYearPct === null) {
        return (
            <Badge className={cx(badgeStyle, className)} as="div" variant="label_default">
                <Text variant="button_small">Brak danych</Text>
            </Badge>
        );
    }

    if (yearOverYearPct === 0) {
        return (
            <Badge className={cx(badgeStyle, className)} as="div" variant="label_default">
                <Text variant="button_small">0%</Text>
            </Badge>
        );
    }

    const isIncrease = yearOverYearPct > 0;

    return (
        <Badge className={cx(badgeStyle, className)} as="div" variant={isIncrease ? "label_danger" : "label_success"}>
            <Text variant="button_small">{getSignedPercentComma(yearOverYearPct)}</Text>
        </Badge>
    );
};

const badgeStyle = css({
    minWidth: "70px",
    justifyContent: "center"
});
import {css, cx} from "@panda/css";

import {Badge} from "@pg-design/badge-module";
import {Text} from "@pg-design/text-module";

import {getSignedPercentComma} from "../../utils/percents_handling_helpers";

interface Props {
    yearOverYearPct: number | null;
    className?: string;
}

export const PricesDistrictChangeBadge = (props: Props) => {
    const {yearOverYearPct, className} = props;

    if (yearOverYearPct === null) {
        return (
            <Badge className={cx(badgeStyle, className)} as="div" variant="label_default">
                <Text variant="button_small">Brak danych</Text>
            </Badge>
        );
    }

    if (yearOverYearPct === 0) {
        return (
            <Badge className={cx(badgeStyle, className)} as="div" variant="label_default">
                <Text variant="button_small">0%</Text>
            </Badge>
        );
    }

    const isIncrease = yearOverYearPct > 0;

    return (
        <Badge className={cx(badgeStyle, className)} as="div" variant={isIncrease ? "label_danger" : "label_success"}>
            <Text variant="button_small">{getSignedPercentComma(yearOverYearPct)}</Text>
        </Badge>
    );
};

const badgeStyle = css({
    minWidth: "70px",
    justifyContent: "center"
});
